import Navbar from './Component/Navbar';

function App() {
  return <Navbar />;
}

export default App;
